import { useEffect } from "react";
import { useParams } from "react-router";
import classNames from 'classnames';

import './survey.scss';
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { /* ISurveyAnswerSocketResponse, */ PageModule, Survey } from "../../../../../types/working-model";
import { ParamsProps } from "../../../live-event";
import { getStylingOverrides } from "../../../utils";
import { TypographyItem } from "../../../../general-ui/typography-item/typography-item";
import Question from './question';
import { useSocket } from "../../../../../connection/socket";
import { getTextValue } from "../../../../../utils/utils";


interface SurveyProps {
	module: PageModule;
	template: TemplateClassNames;
	session: number;
	sessionUuid: string;
	preview?: boolean;
}
const SessionSurvey: React.FC<SurveyProps> = ({ module, template, sessionUuid, preview }) => {
	const { language } = useParams() as ParamsProps;
	const { content, styling_overrides } = module;
	const stylingOverrides = getStylingOverrides(styling_overrides);
	const {
		backgroundColor,
		backgroundImg,
		customHeadingOverrides,
		moduleTitleOverrides
	} = stylingOverrides;

	const { custom_heading } = getTextValue(content, language);

	if (preview) {
		return (
			<section
				className={classNames(
					'surveys session-module',
					template,
					backgroundColor
				)}>
				<div>
					<header>
						<TypographyItem className={classNames('surveys-custom-heading', customHeadingOverrides)} tagName="p">
							{custom_heading}
						</TypographyItem>
					</header>
					{!module?.modules?.length ? null : (
						module.modules.map((survey: Survey) => {
							return (
								<div key={survey.survey} className={classNames('survey-container')}>
									<TypographyItem className={classNames('survey-title evt-heading-4', template, moduleTitleOverrides)} tagName="p">
										{survey?.name?.[language] ?? survey?.name?.base}
									</TypographyItem>
									<Question sessionUuid={sessionUuid} survey={survey} module={module} template={template} preview={preview} />
								</div>
							);
						}))}
				</div>
			</section>
		);
	} else {

		const socket = useSocket(`session-survey-${sessionUuid}`);

		useEffect(() => {
			const handleSurveyAnswerSocket = (data: any) => {
				if (data?.answer?.session_uuid === sessionUuid && module.id === data?.answer?.module) {
					// TODO:
					// update poll result counts in real time (but not for text answers, obviously)
				}
			};

			socket.addListener('survey-answer', handleSurveyAnswerSocket);

			return () => {
				socket.removeListener('survey-answer', handleSurveyAnswerSocket);
			};
		}, [socket, language, sessionUuid, module.id]);

		const renderSurveyQuestions = () => {
			if (!module?.modules?.length) return null;
			return module.modules.map((survey: Survey) => {
				return (
					<div key={survey.survey} className={classNames('survey-container')}>
						<TypographyItem className={classNames('survey-title evt-heading-4', template, moduleTitleOverrides)} tagName="p">
							{survey?.name?.[language] ?? survey?.name?.base}
						</TypographyItem>
						<Question sessionUuid={sessionUuid} survey={survey} module={module} template={template} />
					</div>
				);
			});
		};

		if (!module?.modules?.length) return null;
		return (
			<section
				className={classNames(
					'surveys session-module',
					template,
					backgroundColor
				)}
				style={backgroundImg}
			>
				<div>
					<header>
						<TypographyItem className={classNames('surveys-custom-heading', customHeadingOverrides)} tagName="p">
							{content?.custom_heading?.[language] || content?.custom_heading?.base}
						</TypographyItem>
					</header>
					{renderSurveyQuestions()}
				</div>
			</section>
		);
	}
};

export default SessionSurvey;